import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { IdentifierService } from 'merlin-core';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import {
    PatientDetailsModel,
    PatientDeviceModel,
} from '../../../models/enroll-patient-device-data.model';
import { Lead } from '../../../models/view-leads.model';

@Component({
    selector: 'app-viewleads-dialog',
    templateUrl: './viewleads-dialog.component.html',
    styleUrls: ['./viewleads-dialog.component.scss'],
    standalone: false
})
export class ViewleadsDialogComponent implements OnInit {
    patientInfo: PatientDetailsModel;
    patientDevice: PatientDeviceModel;
    leads: Lead;
    displayedColumns: string[] = [
        'location',
        'manufacturer',
        'modelNum',
        'serialNum',
        'length',
        'implantDate',
    ];
    leadsDatasource: MatTableDataSource<Lead>;
    patientName: string[] =[];
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public identifierService: IdentifierService,
        private localizationService: LocalizationService,
        private dialogRef: MatDialogRef<ViewleadsDialogComponent>
    ) {
        this.dialogRef.disableClose = true;
        
        this.patientInfo = this.data.patient;
        this.patientDevice = this.data.patientDevices?.[0];
        this.leads = this.data.leads;
        if(this.patientInfo?.lastName) { this.patientName.push(this.patientInfo?.lastName) }
        if(this.patientInfo?.firstName) { this.patientName.push(this.patientInfo?.firstName) }
    }

    ngOnInit(): void {
        this.leadsDatasource = new MatTableDataSource(this.data.leads);
    }
    getLocation(row) {
        return this.localizationService.generateLocalizedStr(
            `data.Code.${row.location.qualifier}.Code_Desc.${row.location.code}`
        );
    }
    getViewLeadsFooterText(str) {
        return this.localizationService.generateLocalizedStr(str);
    }
    getDeviceName(){
        let patDevice = this.data.dropdowns ? this.data.dropdowns.devices.filter((dev) => {
            return dev.value == this.data.patientDevices?.[0]?.productId;
          }) : [];
          return patDevice.length !== 0 ? patDevice[0]?.label : '';
    }
    translate(key: string) {
        return this.localizationService.generateLocalizedStr(key);
    }
}
